<template>
  <div>
    <h2>Debounce Demo</h2>
    <DebounceInput
      v-model="inputValue"
      :debounce="1000"
      clearable
      placeholder="Debounced input..."
    />
    <p>Debounced Value: {{ inputValue }}</p>
  </div>
</template>

<script>
import DebounceInput from "@/components/DebounceInput.vue";

export default {
  name: "DemoDebounce",
  components: { DebounceInput },
  data() {
    return {
      inputValue: "",
    };
  },
};
</script>

<style scoped>
input {
  padding: 8px;
  font-size: 16px;
  margin-bottom: 10px;
  width: 250px;
}
</style>
